import { all, fork } from "redux-saga/effects";
import authentication from "./sagas/authentication";
import myProfile from "./sagas/myProfile";
import companies from "./sagas/companies";
import numbers from "./sagas/numbers";
import contractors from "./sagas/contractors";
import qrCodes from "./sagas/qrCodes";
import devices from "./sagas/device";
import punches from "./sagas/punches";
import qrCodeClockIn from "./sagas/qrCodeClockIn";
import deviceClockIn from "./sagas/deviceClockIn";
import users from "./sagas/users";

function* rootSaga() {
  yield all([
    fork(authentication),
    fork(myProfile),
    fork(companies),
    fork(numbers),
    fork(qrCodes),
    fork(punches),
    fork(qrCodeClockIn),
    fork(users),
    fork(contractors),
    fork(devices),
    fork(deviceClockIn),
  ]);
}

export default rootSaga;
